export const SETTLE_FRAMES = 6;
export const MAX_TEXTURE = 2560;

export function backdropScale(width: number, height: number, dpr: number): number {
  const side = Math.max(width, height, 1);
  return Math.max(0.25, Math.min(dpr > 0 ? dpr : 1, 2, MAX_TEXTURE / side));
}

export interface Settle {
  painted: string;
  pending: string;
  stable: number;
}

export function settleStep(state: Settle, key: string, urgent: boolean): boolean {
  if (key === state.painted) {
    state.pending = key;
    state.stable = 0;
    return false;
  }
  if (key !== state.pending) {
    state.pending = key;
    state.stable = 0;
  } else state.stable += 1;
  if (state.painted === '' || urgent || state.stable >= SETTLE_FRAMES) {
    state.painted = key;
    state.stable = 0;
    return true;
  }
  return false;
}
